import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { NewDialogTitle, NewDialogContent } from 'components';

export default function Error({ error, refetch, onClose }) {
  return (
    <>
      {/* <NewDialogTitle title="خطا در بارگذاری" onClose={onClose} /> */}
      {/* <NewDialogContent isPopup> */}
        <Stack height={320} p={1} flex={1} rowGap={1} bgcolor="error.main">
          <Typography variant="subtitle1">{error}</Typography>
          <Button size="small" color="inherit" onClick={refetch}>
            Refresh
          </Button>
        </Stack>
      {/* </NewDialogContent> */}
    </>
  );
}
